// MyPage and user-related translations for all 7 languages
export const mypageTranslations = {
  ja: {
    mypage: {
      title: 'マイページ',
      welcome: 'ようこそ',
      logout: 'ログアウト',
      tabs: {
        profile: 'プロフィール',
        courses: '受講中の講習',
        certificates: '所有資格',
        documents: '書類管理',
      },
      profile: {
        title: '基本情報',
        name: '氏名',
        nameKana: 'フリガナ',
        email: 'メールアドレス',
        phone: '電話番号',
        birthDate: '生年月日',
        address: '住所',
        company: '会社名',
        profileImage: 'プロフィール画像',
        changeImage: '画像を変更',
        save: '保存',
        saveSuccess: 'プロフィールを更新しました',
        saveError: 'プロフィールの更新に失敗しました',
        cancel: 'キャンセル',
        close: '閉じる', incompleteTitle: '個人情報が未入力です', incompleteDescription: 'プロフィールに未入力の項目があります。正確な証明書発行のため、入力をお願いします。', incompleteFields: '未入力項目', editProfile: 'プロフィールを編集',
        department: '部署',
        edit: '編集',
        female: '女性',
        gender: '性別',
        imageSizeError: '画像サイズが大きすぎます',
        imageUpdated: 'プロフィール画像を更新しました',
        imageUploadError: '画像のアップロードに失敗しました',
        male: '男性',
        nationality: '国籍', language: '教材言語', selectPlease: '選択してください',
        postalCode: '郵便番号',
      },
      courses: {
        title: '受講中の講習',
        noCourses: '受講中の講習はありません',
        progress: '進捗',
        startLearning: '学習を開始',
        continueLearning: '学習を続ける',
        completed: '完了',
        videos: '動画',
        quizzes: 'クイズ',
        certificate: '修了証',
        requestCertificate: '修了証を申請',
        viewCertificate: '修了証を見る',
        graduated: '修了',
      },
      certificates: {
        title: '所有資格',
        noCertificates: '所有資格はありません',
        certNumber: '証明書番号',
        courseName: '講習名',
        completionDate: '修了日',
        issueDate: '発行日',
        status: 'ステータス',
        download: 'ダウンロード',
        downloadPdf: 'PDF証明書をダウンロード',
        requestNew: '新規申請',
        pending: '申請中',
        issued: '発行済み',
        card: 'カード型',
        digital: '電子証明書',
        types: '証明書種類',
        downloadError: 'ダウンロードに失敗しました',
        downloaded: 'ダウンロード完了',
        generating: '生成中...',
        requestFailed: '申請に失敗しました',
        requested: '申請しました',
        needPracticalReserve: '修了証の申請には実技講習の受講・合格が必要です。上の「実技予約」から予約してください。',
        practicalPending: '実技予約を受付中です。日程確定後に実技講習を受講してください。',
        practicalApproved: '実技日程が確定しました。実技講習を受講し合格すると修了証を申請できます。',
        practicalFailed: '実技講習が不合格のため修了証を発行できません。再受験について事務局へお問い合わせください。',
        stepReserve: '予約',
        stepConfirm: '日程確定',
        stepAttend: '受講・合格',
      },
      documents: {
        title: '書類管理',
        idDocuments: '身分証明書',
        certDocuments: '資格証明書',
        front: '表面',
        back: '裏面',
        upload: 'アップロード',
        uploadSuccess: 'アップロードしました',
        uploadError: 'アップロードに失敗しました',
        noDocument: '未提出',
        viewHistory: '履歴を見る',
        frontHistory: '表面の履歴',
        backHistory: '裏面の履歴',
        onlyImages: '画像ファイルのみアップロードできます',
        maxFileSize: 'ファイルサイズは10MB以下にしてください',
      },
      quickActions: {
        apply: '講習申込',
        history: '申込履歴',
        editProfile: 'プロフィール編集',
        inProgress: '講習受講中',
        qualifications: '所有資格',
        invoices: '請求書',
        documents: '書類管理',
        practical: '実技予約',
      },
      applications: {
        appliedDate: '申込日',
        pending: '受付中',
        contacted: '連絡済',
        confirmed: '確定',
        passed: '受講済み合格',
        failed: '受講済み不合格',
      },
      invoices: {
        title: '請求書一覧',
        noInvoices: '請求書がありません', unpaid: '未入金', paid: '入金済',
        paid: '入金済',
        unpaid: '未入金',
      },
      practical: {
        submitted: '実技予約を申請しました',
        submitFailed: '申請に失敗しました',
      },
      addNew: '新規追加',
      applicationDetails: '申込詳細',
      bank: '銀行名:',
      cancelled: 'キャンセル',
      cardCertRequest: 'カード型証明書発行依頼',
      cardCertRequested: 'カード型証明書の発行依頼を送信しました',
      certBackHistory: '資格証明書（裏面）履歴',
      certFrontHistory: '資格証明書（表面）履歴',
      certTypeLabel: '修了証タイプ',
      completeVideos: '全ての動画の視聴を完了してください',
      completedDate: '受講完了日:',
      courseDate: '受講日:',
      digitalCertRequest: '電子証明書発行依頼',
      digitalCertRequested: '電子証明書の発行依頼を送信しました',
      id: '身分証',
      idBackHistory: '身分証明書（裏面）履歴',
      idFrontHistory: '身分証明書（表面）履歴',
      loggedOut: 'ログアウトしました',
      notes: '注意事項',
      other: 'その他',
      passQuizzes: '全てのテストに合格してください',
      processing: '処理中',
      submitCertRequest: '発行依頼を送信',
      submitting: '送信中...',
      cert: '資格証',
    },
    auth: {
      login: 'ログイン',
      register: '新規登録',
      email: 'メールアドレス',
      password: 'パスワード',
      confirmPassword: 'パスワード（確認）',
      name: '氏名',
      nameKana: 'フリガナ',
      phone: '電話番号',
      birthDate: '生年月日',
      address: '住所',
      company: '会社名',
      loginButton: 'ログイン',
      registerButton: '登録',
      switchToRegister: '新規登録はこちら',
      switchToLogin: 'ログインはこちら',
      forgotPassword: 'パスワードを忘れた方',
      loginSuccess: 'ログインしました',
      loginError: 'ログインに失敗しました',
      registerSuccess: '登録完了しました',
      registerError: '登録に失敗しました',
      emailRequired: 'メールアドレスは必須です',
      passwordRequired: 'パスワードは必須です',
      passwordMismatch: 'パスワードが一致しません',
      verifyEmail: 'メール認証',
      verifyEmailMessage: '認証メールを送信しました。メールをご確認ください。',
      alreadyHaveAccount: 'すでにアカウントをお持ちの方',
      noAccount: 'アカウントをお持ちでない方',
    },
  },
  en: {
    mypage: {
      title: 'My Page',
      welcome: 'Welcome',
      logout: 'Logout',
      tabs: {
        profile: 'Profile',
        courses: 'My Courses',
        certificates: 'Certificates',
        documents: 'Documents',
      },
      profile: {
        title: 'Basic Information',
        name: 'Name',
        nameKana: 'Name (Phonetic)',
        email: 'Email',
        phone: 'Phone',
        birthDate: 'Date of Birth',
        address: 'Address',
        company: 'Company',
        profileImage: 'Profile Image',
        changeImage: 'Change Image',
        save: 'Save',
        saveSuccess: 'Profile updated',
        saveError: 'Failed to update profile',
        cancel: 'Cancel',
        close: 'Close', incompleteTitle: 'Profile Incomplete', incompleteDescription: 'Some profile fields are missing. Please complete your profile for accurate certificate issuance.', incompleteFields: 'Missing fields', editProfile: 'Edit Profile',
        department: 'Department',
        edit: 'Edit',
        female: 'Female',
        gender: 'Gender',
        imageSizeError: 'Image size is too large',
        imageUpdated: 'Profile image updated',
        imageUploadError: 'Failed to upload image',
        male: 'Male',
        nationality: 'Nationality', language: 'Material Language', selectPlease: 'Please select',
        postalCode: 'Postal Code',
      },
      courses: {
        title: 'My Courses',
        noCourses: 'No enrolled courses',
        progress: 'Progress',
        startLearning: 'Start Learning',
        continueLearning: 'Continue Learning',
        completed: 'Completed',
        videos: 'Videos',
        quizzes: 'Quizzes',
        certificate: 'Certificate',
        requestCertificate: 'Request Certificate',
        viewCertificate: 'View Certificate',
        graduated: 'Graduated',
      },
      certificates: {
        title: 'My Certificates',
        noCertificates: 'No certificates',
        certNumber: 'Certificate Number',
        courseName: 'Course Name',
        completionDate: 'Completion Date',
        issueDate: 'Issue Date',
        status: 'Status',
        download: 'Download',
        downloadPdf: 'Download PDF Certificate',
        requestNew: 'Request New',
        pending: 'Pending',
        issued: 'Issued',
        card: 'Card Type',
        digital: 'Digital Certificate',
        types: 'Certificate Types',
        downloadError: 'Download failed',
        downloaded: 'Download complete',
        generating: 'Generating...',
        requestFailed: 'Request failed',
        requested: 'Requested successfully',
        needPracticalReserve: 'To request a certificate, you must attend and pass the practical training. Please book it using the "Book Practical" button above.',
        practicalPending: 'Your practical booking is being processed. Please attend the training once the date is confirmed.',
        practicalApproved: 'Your practical training date is confirmed. You can request a certificate after attending and passing it.',
        practicalFailed: 'The certificate cannot be issued because the practical training was not passed. Please contact the office about retaking it.',
        stepReserve: 'Book',
        stepConfirm: 'Confirmed',
        stepAttend: 'Attend & Pass',
      },
      documents: {
        title: 'Document Management',
        idDocuments: 'ID Documents',
        certDocuments: 'Certification Documents',
        front: 'Front',
        back: 'Back',
        upload: 'Upload',
        uploadSuccess: 'Uploaded successfully',
        uploadError: 'Upload failed',
        noDocument: 'Not submitted',
        viewHistory: 'View History',
        frontHistory: 'Front History',
        backHistory: 'Back History',
        onlyImages: 'Only image files can be uploaded',
        maxFileSize: 'File size must be 10MB or less',
      },
      quickActions: {
        apply: 'Apply for Course',
        history: 'Application History',
        editProfile: 'Edit Profile',
        inProgress: 'Courses In Progress',
        qualifications: 'Qualifications',
        invoices: 'Invoices',
        documents: 'Documents',
        practical: 'Practical Reservation',
      },
      applications: {
        appliedDate: 'Applied Date',
        pending: 'Pending',
        contacted: 'Contacted',
        confirmed: 'Confirmed',
        passed: 'Passed',
        failed: 'Failed',
      },
      invoices: {
        title: 'Invoice List',
        noInvoices: 'No invoices', unpaid: 'Unpaid', paid: 'Paid',
        paid: 'Paid',
        unpaid: 'Unpaid',
      },
      practical: {
        submitted: 'Practical reservation submitted',
        submitFailed: 'Submission failed',
      },
      addNew: 'Add New',
      applicationDetails: 'Application Details',
      bank: 'Bank Name:',
      cancelled: 'Cancelled',
      cardCertRequest: 'Card Certificate Request',
      cardCertRequested: 'Card certificate request submitted',
      certBackHistory: 'Certificate (Back) History',
      certFrontHistory: 'Certificate (Front) History',
      certTypeLabel: 'Certificate Type',
      completeVideos: 'Please complete watching all videos',
      completedDate: 'Completion Date:',
      courseDate: 'Course Date:',
      digitalCertRequest: 'Digital Certificate Request',
      digitalCertRequested: 'Digital certificate request submitted',
      id: 'ID Document',
      idBackHistory: 'ID Document (Back) History',
      idFrontHistory: 'ID Document (Front) History',
      loggedOut: 'Logged out',
      notes: 'Notes',
      other: 'Other',
      passQuizzes: 'Please pass all quizzes',
      processing: 'Processing',
      submitCertRequest: 'Submit Request',
      submitting: 'Submitting...',
      cert: 'Certificate',
    },
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      name: 'Full Name',
      nameKana: 'Name (Phonetic)',
      phone: 'Phone Number',
      birthDate: 'Date of Birth',
      address: 'Address',
      company: 'Company',
      loginButton: 'Login',
      registerButton: 'Register',
      switchToRegister: 'Register here',
      switchToLogin: 'Login here',
      forgotPassword: 'Forgot Password?',
      loginSuccess: 'Logged in successfully',
      loginError: 'Login failed',
      registerSuccess: 'Registration complete',
      registerError: 'Registration failed',
      emailRequired: 'Email is required',
      passwordRequired: 'Password is required',
      passwordMismatch: 'Passwords do not match',
      verifyEmail: 'Verify Email',
      verifyEmailMessage: 'Verification email sent. Please check your email.',
      alreadyHaveAccount: 'Already have an account?',
      noAccount: 'Don\'t have an account?',
    },
  },
  pt: {
    mypage: {
      title: 'Minha Pagina',
      welcome: 'Bem-vindo',
      logout: 'Sair',
      tabs: {
        profile: 'Perfil',
        courses: 'Meus Cursos',
        certificates: 'Certificados',
        documents: 'Documentos',
      },
      profile: {
        title: 'Informacoes Basicas',
        name: 'Nome',
        nameKana: 'Nome (Fonetico)',
        email: 'E-mail',
        phone: 'Telefone',
        birthDate: 'Data de Nascimento',
        address: 'Endereco',
        company: 'Empresa',
        profileImage: 'Foto de Perfil',
        changeImage: 'Alterar Foto',
        save: 'Salvar',
        saveSuccess: 'Perfil atualizado',
        saveError: 'Falha ao atualizar perfil',
        cancel: 'Cancelar',
        close: 'Cerrar', incompleteTitle: 'Perfil Incompleto', incompleteDescription: 'Faltan algunos campos del perfil. Complete su perfil para la emision correcta de certificados.', incompleteFields: 'Campos faltantes', editProfile: 'Editar Perfil',
        close: 'Fechar', incompleteTitle: 'Perfil Incompleto', incompleteDescription: 'Alguns campos do perfil estao faltando. Complete seu perfil para emissao correta de certificados.', incompleteFields: 'Campos faltando', editProfile: 'Editar Perfil',
        department: 'Departamento',
        edit: 'Editar',
        female: 'Feminino',
        gender: 'Genero',
        imageSizeError: 'Tamanho da imagem muito grande',
        imageUpdated: 'Foto de perfil atualizada',
        imageUploadError: 'Falha ao enviar imagem',
        male: 'Masculino',
        nationality: 'Nacionalidade', language: 'Idioma do Material', selectPlease: 'Selecione',
        postalCode: 'CEP',
      },
      courses: {
        title: 'Meus Cursos',
        noCourses: 'Nenhum curso inscrito',
        progress: 'Progresso',
        startLearning: 'Iniciar Aprendizado',
        continueLearning: 'Continuar Aprendizado',
        completed: 'Concluido',
        videos: 'Videos',
        quizzes: 'Quizzes',
        certificate: 'Certificado',
        requestCertificate: 'Solicitar Certificado',
        viewCertificate: 'Ver Certificado',
        graduated: 'Formado',
      },
      certificates: {
        title: 'Meus Certificados',
        noCertificates: 'Nenhum certificado',
        certNumber: 'Numero do Certificado',
        courseName: 'Nome do Curso',
        completionDate: 'Data de Conclusao',
        issueDate: 'Data de Emissao',
        status: 'Status',
        download: 'Baixar',
        downloadPdf: 'Baixar Certificado PDF',
        requestNew: 'Solicitar Novo',
        pending: 'Pendente',
        issued: 'Emitido',
        card: 'Tipo Cartao',
        digital: 'Certificado Digital',
        types: 'Tipos de Certificado',
        downloadError: 'Falha no download',
        downloaded: 'Download concluido',
        generating: 'Gerando...',
        requestFailed: 'Falha na solicitacao',
        requested: 'Solicitado com sucesso',
        needPracticalReserve: 'Para solicitar o certificado, e necessario participar e ser aprovado no treinamento pratico. Reserve pelo botao "Reservar Pratica" acima.',
        practicalPending: 'Sua reserva de pratica esta em analise. Participe do treinamento apos a confirmacao da data.',
        practicalApproved: 'A data do treinamento pratico foi confirmada. Voce podera solicitar o certificado apos participar e ser aprovado.',
        practicalFailed: 'O certificado nao pode ser emitido porque o treinamento pratico nao foi aprovado. Entre em contato com o escritorio sobre a reavaliacao.',
        stepReserve: 'Reservar',
        stepConfirm: 'Data',
        stepAttend: 'Aprovar',
      },
      documents: {
        title: 'Gerenciamento de Documentos',
        idDocuments: 'Documentos de ID',
        certDocuments: 'Documentos de Certificacao',
        front: 'Frente',
        back: 'Verso',
        upload: 'Enviar',
        uploadSuccess: 'Enviado com sucesso',
        uploadError: 'Falha no envio',
        noDocument: 'Nao enviado',
        viewHistory: 'Ver Historico',
        frontHistory: 'Historico da Frente',
        backHistory: 'Historico do Verso',
        onlyImages: 'Apenas arquivos de imagem podem ser enviados',
        maxFileSize: 'O tamanho do arquivo deve ser 10MB ou menos',
      },
      quickActions: {
        apply: 'Inscrever-se no Curso',
        history: 'Historico de Inscricoes',
        editProfile: 'Editar Perfil',
        inProgress: 'Cursos em Andamento',
        qualifications: 'Qualificacoes',
        invoices: 'Faturas',
        documents: 'Documentos',
        practical: 'Reserva Pratica',
      },
      applications: {
        appliedDate: 'Data de Inscricao',
        pending: 'Pendente',
        contacted: 'Contatado',
        confirmed: 'Confirmado',
        passed: 'Aprovado',
        failed: 'Reprovado',
      },
      invoices: {
        title: 'Lista de Faturas',
        noInvoices: 'Sem faturas', unpaid: 'Nao Pago', paid: 'Pago',
        paid: 'Pago',
        unpaid: 'Nao pago',
      },
      practical: {
        submitted: 'Reserva pratica enviada',
        submitFailed: 'Falha no envio',
      },
      addNew: 'Adicionar Novo',
      applicationDetails: 'Detalhes da Inscricao',
      bank: 'Nome do Banco:',
      cancelled: 'Cancelado',
      cardCertRequest: 'Solicitacao de Certificado em Cartao',
      cardCertRequested: 'Solicitacao de certificado em cartao enviada',
      certBackHistory: 'Historico do Certificado (Verso)',
      certFrontHistory: 'Historico do Certificado (Frente)',
      certTypeLabel: 'Tipo de Certificado',
      completeVideos: 'Por favor, assista todos os videos',
      completedDate: 'Data de Conclusao:',
      courseDate: 'Data do Curso:',
      digitalCertRequest: 'Solicitacao de Certificado Digital',
      digitalCertRequested: 'Solicitacao de certificado digital enviada',
      id: 'Documento de ID',
      idBackHistory: 'Historico do ID (Verso)',
      idFrontHistory: 'Historico do ID (Frente)',
      loggedOut: 'Desconectado',
      notes: 'Observacoes',
      other: 'Outros',
      passQuizzes: 'Por favor, passe em todos os quizzes',
      processing: 'Processando',
      submitCertRequest: 'Enviar Solicitacao',
      submitting: 'Enviando...',
      cert: 'Certificado',
    },
    auth: {
      login: 'Entrar',
      register: 'Registrar',
      email: 'E-mail',
      password: 'Senha',
      confirmPassword: 'Confirmar Senha',
      name: 'Nome Completo',
      nameKana: 'Nome (Fonetico)',
      phone: 'Telefone',
      birthDate: 'Data de Nascimento',
      address: 'Endereco',
      company: 'Empresa',
      loginButton: 'Entrar',
      registerButton: 'Registrar',
      switchToRegister: 'Registre-se aqui',
      switchToLogin: 'Entre aqui',
      forgotPassword: 'Esqueceu a senha?',
      loginSuccess: 'Login realizado',
      loginError: 'Falha no login',
      registerSuccess: 'Registro concluido',
      registerError: 'Falha no registro',
      emailRequired: 'E-mail e obrigatorio',
      passwordRequired: 'Senha e obrigatoria',
      passwordMismatch: 'Senhas nao coincidem',
      verifyEmail: 'Verificar E-mail',
      verifyEmailMessage: 'E-mail de verificacao enviado. Verifique seu e-mail.',
      alreadyHaveAccount: 'Ja tem uma conta?',
      noAccount: 'Nao tem uma conta?',
    },
  },
  es: {
    mypage: {
      title: 'Mi Pagina',
      welcome: 'Bienvenido',
      logout: 'Cerrar Sesion',
      tabs: {
        profile: 'Perfil',
        courses: 'Mis Cursos',
        certificates: 'Certificados',
        documents: 'Documentos',
      },
      profile: {
        title: 'Informacion Basica',
        name: 'Nombre',
        nameKana: 'Nombre (Fonetico)',
        email: 'Correo',
        phone: 'Telefono',
        birthDate: 'Fecha de Nacimiento',
        address: 'Direccion',
        company: 'Empresa',
        profileImage: 'Foto de Perfil',
        changeImage: 'Cambiar Foto',
        save: 'Guardar',
        saveSuccess: 'Perfil actualizado',
        saveError: 'Error al actualizar perfil',
        cancel: 'Cancelar',
        department: 'Departamento',
        edit: 'Editar',
        female: 'Femenino',
        gender: 'Genero',
        imageSizeError: 'El tamano de la imagen es muy grande',
        imageUpdated: 'Foto de perfil actualizada',
        imageUploadError: 'Error al subir la imagen',
        male: 'Masculino',
        nationality: 'Nacionalidad', language: 'Idioma del Material', selectPlease: 'Seleccione',
        postalCode: 'Codigo Postal',
      },
      courses: {
        title: 'Mis Cursos',
        noCourses: 'No hay cursos inscritos',
        progress: 'Progreso',
        startLearning: 'Iniciar Aprendizaje',
        continueLearning: 'Continuar Aprendizaje',
        completed: 'Completado',
        videos: 'Videos',
        quizzes: 'Cuestionarios',
        certificate: 'Certificado',
        requestCertificate: 'Solicitar Certificado',
        viewCertificate: 'Ver Certificado',
        graduated: 'Graduado',
      },
      certificates: {
        title: 'Mis Certificados',
        noCertificates: 'Sin certificados',
        certNumber: 'Numero de Certificado',
        courseName: 'Nombre del Curso',
        completionDate: 'Fecha de Finalizacion',
        issueDate: 'Fecha de Emision',
        status: 'Estado',
        download: 'Descargar',
        downloadPdf: 'Descargar Certificado PDF',
        requestNew: 'Solicitar Nuevo',
        pending: 'Pendiente',
        issued: 'Emitido',
        card: 'Tipo Tarjeta',
        digital: 'Certificado Digital',
        types: 'Tipos de Certificado',
        downloadError: 'Error en la descarga',
        downloaded: 'Descarga completada',
        generating: 'Generando...',
        requestFailed: 'Error en la solicitud',
        requested: 'Solicitado exitosamente',
        needPracticalReserve: 'Para solicitar el certificado, debe asistir y aprobar la formacion practica. Reservela con el boton "Reservar Practica" de arriba.',
        practicalPending: 'Su reserva de practica esta en proceso. Asista a la formacion una vez confirmada la fecha.',
        practicalApproved: 'La fecha de la formacion practica esta confirmada. Podra solicitar el certificado tras asistir y aprobar.',
        practicalFailed: 'No se puede emitir el certificado porque no se aprobo la formacion practica. Contacte con la oficina sobre la repeticion.',
        stepReserve: 'Reservar',
        stepConfirm: 'Fecha',
        stepAttend: 'Aprobar',
      },
      documents: {
        title: 'Gestion de Documentos',
        idDocuments: 'Documentos de ID',
        certDocuments: 'Documentos de Certificacion',
        front: 'Frente',
        back: 'Reverso',
        upload: 'Subir',
        uploadSuccess: 'Subido exitosamente',
        uploadError: 'Error al subir',
        noDocument: 'No enviado',
        viewHistory: 'Ver Historial',
        frontHistory: 'Historial del Frente',
        backHistory: 'Historial del Reverso',
        onlyImages: 'Solo se pueden subir archivos de imagen',
        maxFileSize: 'El tamano del archivo debe ser 10MB o menos',
      },
      quickActions: {
        apply: 'Inscribirse al Curso',
        history: 'Historial de Inscripciones',
        editProfile: 'Editar Perfil',
        inProgress: 'Cursos en Progreso',
        qualifications: 'Calificaciones',
        invoices: 'Facturas',
        documents: 'Documentos',
        practical: 'Reserva Practica',
      },
      applications: {
        appliedDate: 'Fecha de Inscripcion',
        pending: 'Pendiente',
        contacted: 'Contactado',
        confirmed: 'Confirmado',
        passed: 'Aprobado',
        failed: 'Reprobado',
      },
      invoices: {
        title: 'Lista de Facturas',
        noInvoices: 'Sin facturas', unpaid: 'No Pagado', paid: 'Pagado',
        paid: 'Pagado',
        unpaid: 'No pagado',
      },
      practical: {
        submitted: 'Reserva practica enviada',
        submitFailed: 'Error en el envio',
      },
      addNew: 'Agregar Nuevo',
      applicationDetails: 'Detalles de Inscripcion',
      bank: 'Nombre del Banco:',
      cancelled: 'Cancelado',
      cardCertRequest: 'Solicitud de Certificado en Tarjeta',
      cardCertRequested: 'Solicitud de certificado en tarjeta enviada',
      certBackHistory: 'Historial del Certificado (Reverso)',
      certFrontHistory: 'Historial del Certificado (Frente)',
      certTypeLabel: 'Tipo de Certificado',
      completeVideos: 'Por favor, vea todos los videos',
      completedDate: 'Fecha de Finalizacion:',
      courseDate: 'Fecha del Curso:',
      digitalCertRequest: 'Solicitud de Certificado Digital',
      digitalCertRequested: 'Solicitud de certificado digital enviada',
      id: 'Documento de ID',
      idBackHistory: 'Historial del ID (Reverso)',
      idFrontHistory: 'Historial del ID (Frente)',
      loggedOut: 'Sesion cerrada',
      notes: 'Notas',
      other: 'Otros',
      passQuizzes: 'Por favor, apruebe todos los cuestionarios',
      processing: 'Procesando',
      submitCertRequest: 'Enviar Solicitud',
      submitting: 'Enviando...',
      cert: 'Certificado',
    },
    auth: {
      login: 'Iniciar Sesion',
      register: 'Registrarse',
      email: 'Correo Electronico',
      password: 'Contrasena',
      confirmPassword: 'Confirmar Contrasena',
      name: 'Nombre Completo',
      nameKana: 'Nombre (Fonetico)',
      phone: 'Telefono',
      birthDate: 'Fecha de Nacimiento',
      address: 'Direccion',
      company: 'Empresa',
      loginButton: 'Iniciar Sesion',
      registerButton: 'Registrarse',
      switchToRegister: 'Registrese aqui',
      switchToLogin: 'Inicie sesion aqui',
      forgotPassword: 'Olvido su contrasena?',
      loginSuccess: 'Sesion iniciada',
      loginError: 'Error al iniciar sesion',
      registerSuccess: 'Registro completado',
      registerError: 'Error en el registro',
      emailRequired: 'El correo es requerido',
      passwordRequired: 'La contrasena es requerida',
      passwordMismatch: 'Las contrasenas no coinciden',
      verifyEmail: 'Verificar Correo',
      verifyEmailMessage: 'Correo de verificacion enviado. Revise su correo.',
      alreadyHaveAccount: 'Ya tiene una cuenta?',
      noAccount: 'No tiene una cuenta?',
    },
  },
  vi: {
    mypage: {
      title: 'Trang Cua Toi',
      welcome: 'Chao mung',
      logout: 'Dang Xuat',
      tabs: {
        profile: 'Ho So',
        courses: 'Khoa Hoc Cua Toi',
        certificates: 'Chung Chi',
        documents: 'Tai Lieu',
      },
      profile: {
        title: 'Thong Tin Co Ban',
        name: 'Ho Ten',
        nameKana: 'Ten (Phien am)',
        email: 'Email',
        phone: 'Dien Thoai',
        birthDate: 'Ngay Sinh',
        address: 'Dia Chi',
        company: 'Cong Ty',
        profileImage: 'Anh Dai Dien',
        changeImage: 'Doi Anh',
        save: 'Luu',
        saveSuccess: 'Da cap nhat ho so',
        saveError: 'Cap nhat ho so that bai',
        cancel: 'Huy',
        close: 'Dong', incompleteTitle: 'Ho so chua day du', incompleteDescription: 'Mot so thong tin chua duoc nhap. Vui long hoan thanh ho so.', incompleteFields: 'Thong tin con thieu', editProfile: 'Chinh sua ho so',
        department: 'Phong ban',
        edit: 'Chinh sua',
        female: 'Nu',
        gender: 'Gioi tinh',
        imageSizeError: 'Kich thuoc anh qua lon',
        imageUpdated: 'Da cap nhat anh dai dien',
        imageUploadError: 'Tai anh len that bai',
        male: 'Nam',
        nationality: 'Quoc tich', language: 'Ngon ngu tai lieu', selectPlease: 'Vui long chon',
        postalCode: 'Ma buu dien',
      },
      courses: {
        title: 'Khoa Hoc Cua Toi',
        noCourses: 'Chua dang ky khoa hoc nao',
        progress: 'Tien Do',
        startLearning: 'Bat Dau Hoc',
        continueLearning: 'Tiep Tuc Hoc',
        completed: 'Hoan Thanh',
        videos: 'Video',
        quizzes: 'Bai Kiem Tra',
        certificate: 'Chung Chi',
        requestCertificate: 'Yeu Cau Chung Chi',
        viewCertificate: 'Xem Chung Chi',
        graduated: 'Tot nghiep',
      },
      certificates: {
        title: 'Chung Chi Cua Toi',
        noCertificates: 'Chua co chung chi',
        certNumber: 'So Chung Chi',
        courseName: 'Ten Khoa Hoc',
        completionDate: 'Ngay Hoan Thanh',
        issueDate: 'Ngay Cap',
        status: 'Trang Thai',
        download: 'Tai Xuong',
        downloadPdf: 'Tai Chung Chi PDF',
        requestNew: 'Yeu Cau Moi',
        pending: 'Dang Cho',
        issued: 'Da Cap',
        card: 'Loai The',
        digital: 'Chung Chi So',
        types: 'Loai Chung Chi',
        downloadError: 'Tai xuong that bai',
        downloaded: 'Tai xuong hoan tat',
        generating: 'Dang tao...',
        requestFailed: 'Yeu cau that bai',
        requested: 'Da yeu cau thanh cong',
        needPracticalReserve: 'De yeu cau chung chi, ban phai tham gia va dat phan thuc hanh. Hay dat lich bang nut "Dat thuc hanh" o tren.',
        practicalPending: 'Dat lich thuc hanh cua ban dang duoc xu ly. Hay tham gia khi ngay duoc xac nhan.',
        practicalApproved: 'Ngay thuc hanh da duoc xac nhan. Ban co the yeu cau chung chi sau khi tham gia va dat.',
        practicalFailed: 'Khong the cap chung chi vi phan thuc hanh chua dat. Vui long lien he van phong ve viec thi lai.',
        stepReserve: 'Dat lich',
        stepConfirm: 'Xac nhan',
        stepAttend: 'Hoan thanh',
      },
      documents: {
        title: 'Quan Ly Tai Lieu',
        idDocuments: 'Giay To Tuy Than',
        certDocuments: 'Giay Chung Nhan',
        front: 'Mat Truoc',
        back: 'Mat Sau',
        upload: 'Tai Len',
        uploadSuccess: 'Tai len thanh cong',
        uploadError: 'Tai len that bai',
        noDocument: 'Chua gui',
        viewHistory: 'Xem Lich Su',
        frontHistory: 'Lich su mat truoc',
        backHistory: 'Lich su mat sau',
        onlyImages: 'Chi co the tai len file hinh anh',
        maxFileSize: 'Kich thuoc file phai 10MB tro xuong',
      },
      quickActions: {
        apply: 'Dang ky khoa hoc',
        history: 'Lich su dang ky',
        editProfile: 'Chinh sua ho so',
        inProgress: 'Khoa hoc dang hoc',
        qualifications: 'Bang cap',
        invoices: 'Hoa don',
        documents: 'Tai lieu',
        practical: 'Dat lich thuc hanh',
      },
      applications: {
        appliedDate: 'Ngay dang ky',
        pending: 'Dang cho',
        contacted: 'Da lien he',
        confirmed: 'Da xac nhan',
        passed: 'Dat',
        failed: 'Khong dat',
      },
      invoices: {
        title: 'Danh sach hoa don',
        noInvoices: 'Khong co hoa don', unpaid: 'Chua thanh toan', paid: 'Da thanh toan',
        paid: 'Da thanh toan',
        unpaid: 'Chua thanh toan',
      },
      practical: {
        submitted: 'Da gui dat lich thuc hanh',
        submitFailed: 'Gui that bai',
      },
      addNew: 'Them moi',
      applicationDetails: 'Chi tiet dang ky',
      bank: 'Ten ngan hang:',
      cancelled: 'Da huy',
      cardCertRequest: 'Yeu cau chung chi dang the',
      cardCertRequested: 'Da gui yeu cau chung chi dang the',
      certBackHistory: 'Lich su chung chi (Mat sau)',
      certFrontHistory: 'Lich su chung chi (Mat truoc)',
      certTypeLabel: 'Loai chung chi',
      completeVideos: 'Vui long xem het tat ca video',
      completedDate: 'Ngay hoan thanh:',
      courseDate: 'Ngay khoa hoc:',
      digitalCertRequest: 'Yeu cau chung chi so',
      digitalCertRequested: 'Da gui yeu cau chung chi so',
      id: 'Giay to tuy than',
      idBackHistory: 'Lich su giay to (Mat sau)',
      idFrontHistory: 'Lich su giay to (Mat truoc)',
      loggedOut: 'Da dang xuat',
      notes: 'Ghi chu',
      other: 'Khac',
      passQuizzes: 'Vui long vuot qua tat ca bai kiem tra',
      processing: 'Dang xu ly',
      submitCertRequest: 'Gui yeu cau',
      submitting: 'Dang gui...',
      cert: 'Chung chi',
    },
    auth: {
      login: 'Dang Nhap',
      register: 'Dang Ky',
      email: 'Email',
      password: 'Mat Khau',
      confirmPassword: 'Xac Nhan Mat Khau',
      name: 'Ho Ten',
      nameKana: 'Ten (Phien am)',
      phone: 'Dien Thoai',
      birthDate: 'Ngay Sinh',
      address: 'Dia Chi',
      company: 'Cong Ty',
      loginButton: 'Dang Nhap',
      registerButton: 'Dang Ky',
      switchToRegister: 'Dang ky tai day',
      switchToLogin: 'Dang nhap tai day',
      forgotPassword: 'Quen mat khau?',
      loginSuccess: 'Dang nhap thanh cong',
      loginError: 'Dang nhap that bai',
      registerSuccess: 'Dang ky hoan tat',
      registerError: 'Dang ky that bai',
      emailRequired: 'Email la bat buoc',
      passwordRequired: 'Mat khau la bat buoc',
      passwordMismatch: 'Mat khau khong khop',
      verifyEmail: 'Xac Minh Email',
      verifyEmailMessage: 'Email xac minh da duoc gui. Vui long kiem tra email.',
      alreadyHaveAccount: 'Da co tai khoan?',
      noAccount: 'Chua co tai khoan?',
    },
  },
  id: {
    mypage: {
      title: 'Halaman Saya',
      welcome: 'Selamat Datang',
      logout: 'Keluar',
      tabs: {
        profile: 'Profil',
        courses: 'Kursus Saya',
        certificates: 'Sertifikat',
        documents: 'Dokumen',
      },
      profile: {
        title: 'Informasi Dasar',
        name: 'Nama',
        nameKana: 'Nama (Fonetik)',
        email: 'Email',
        phone: 'Telepon',
        birthDate: 'Tanggal Lahir',
        address: 'Alamat',
        company: 'Perusahaan',
        profileImage: 'Foto Profil',
        changeImage: 'Ganti Foto',
        save: 'Simpan',
        saveSuccess: 'Profil diperbarui',
        saveError: 'Gagal memperbarui profil',
        cancel: 'Batal',
        close: 'Tutup', incompleteTitle: 'Profil Belum Lengkap', incompleteDescription: 'Beberapa data profil belum diisi. Silakan lengkapi profil Anda.', incompleteFields: 'Data yang belum diisi', editProfile: 'Edit Profil',
        department: 'Departemen',
        edit: 'Edit',
        female: 'Perempuan',
        gender: 'Jenis Kelamin',
        imageSizeError: 'Ukuran gambar terlalu besar',
        imageUpdated: 'Foto profil diperbarui',
        imageUploadError: 'Gagal mengunggah gambar',
        male: 'Laki-laki',
        nationality: 'Kewarganegaraan', language: 'Bahasa Materi', selectPlease: 'Silakan pilih',
        postalCode: 'Kode Pos',
      },
      courses: {
        title: 'Kursus Saya',
        noCourses: 'Tidak ada kursus terdaftar',
        progress: 'Kemajuan',
        startLearning: 'Mulai Belajar',
        continueLearning: 'Lanjutkan Belajar',
        completed: 'Selesai',
        videos: 'Video',
        quizzes: 'Kuis',
        certificate: 'Sertifikat',
        requestCertificate: 'Minta Sertifikat',
        viewCertificate: 'Lihat Sertifikat',
        graduated: 'Lulus',
      },
      certificates: {
        title: 'Sertifikat Saya',
        noCertificates: 'Tidak ada sertifikat',
        certNumber: 'Nomor Sertifikat',
        courseName: 'Nama Kursus',
        completionDate: 'Tanggal Selesai',
        issueDate: 'Tanggal Terbit',
        status: 'Status',
        download: 'Unduh',
        downloadPdf: 'Unduh Sertifikat PDF',
        requestNew: 'Minta Baru',
        pending: 'Tertunda',
        issued: 'Terbit',
        card: 'Jenis Kartu',
        digital: 'Sertifikat Digital',
        types: 'Jenis Sertifikat',
        downloadError: 'Unduhan gagal',
        downloaded: 'Unduhan selesai',
        generating: 'Membuat...',
        requestFailed: 'Permintaan gagal',
        requested: 'Berhasil diminta',
        needPracticalReserve: 'Untuk meminta sertifikat, Anda harus mengikuti dan lulus pelatihan praktik. Pesan melalui tombol "Pesan Praktik" di atas.',
        practicalPending: 'Reservasi praktik Anda sedang diproses. Ikuti pelatihan setelah tanggal dikonfirmasi.',
        practicalApproved: 'Tanggal pelatihan praktik telah dikonfirmasi. Anda dapat meminta sertifikat setelah mengikuti dan lulus.',
        practicalFailed: 'Sertifikat tidak dapat diterbitkan karena pelatihan praktik tidak lulus. Hubungi kantor mengenai pengulangan.',
        stepReserve: 'Pesan',
        stepConfirm: 'Konfirmasi',
        stepAttend: 'Lulus',
      },
      documents: {
        title: 'Manajemen Dokumen',
        idDocuments: 'Dokumen ID',
        certDocuments: 'Dokumen Sertifikasi',
        front: 'Depan',
        back: 'Belakang',
        upload: 'Unggah',
        uploadSuccess: 'Berhasil diunggah',
        uploadError: 'Gagal mengunggah',
        noDocument: 'Belum dikirim',
        viewHistory: 'Lihat Riwayat',
        frontHistory: 'Riwayat Depan',
        backHistory: 'Riwayat Belakang',
        onlyImages: 'Hanya file gambar yang dapat diunggah',
        maxFileSize: 'Ukuran file harus 10MB atau kurang',
      },
      quickActions: {
        apply: 'Daftar Kursus',
        history: 'Riwayat Pendaftaran',
        editProfile: 'Edit Profil',
        inProgress: 'Kursus Berlangsung',
        qualifications: 'Kualifikasi',
        invoices: 'Faktur',
        documents: 'Dokumen',
        practical: 'Reservasi Praktik',
      },
      applications: {
        appliedDate: 'Tanggal Pendaftaran',
        pending: 'Tertunda',
        contacted: 'Dihubungi',
        confirmed: 'Dikonfirmasi',
        passed: 'Lulus',
        failed: 'Tidak Lulus',
      },
      invoices: {
        title: 'Daftar Faktur',
        noInvoices: 'Tidak ada faktur', unpaid: 'Belum Dibayar', paid: 'Sudah Dibayar',
        paid: 'Dibayar',
        unpaid: 'Belum dibayar',
      },
      practical: {
        submitted: 'Reservasi praktik dikirim',
        submitFailed: 'Pengiriman gagal',
      },
      addNew: 'Tambah Baru',
      applicationDetails: 'Detail Pendaftaran',
      bank: 'Nama Bank:',
      cancelled: 'Dibatalkan',
      cardCertRequest: 'Permintaan Sertifikat Kartu',
      cardCertRequested: 'Permintaan sertifikat kartu dikirim',
      certBackHistory: 'Riwayat Sertifikat (Belakang)',
      certFrontHistory: 'Riwayat Sertifikat (Depan)',
      certTypeLabel: 'Jenis Sertifikat',
      completeVideos: 'Silakan tonton semua video',
      completedDate: 'Tanggal Selesai:',
      courseDate: 'Tanggal Kursus:',
      digitalCertRequest: 'Permintaan Sertifikat Digital',
      digitalCertRequested: 'Permintaan sertifikat digital dikirim',
      id: 'Dokumen ID',
      idBackHistory: 'Riwayat ID (Belakang)',
      idFrontHistory: 'Riwayat ID (Depan)',
      loggedOut: 'Telah keluar',
      notes: 'Catatan',
      other: 'Lainnya',
      passQuizzes: 'Silakan lulus semua kuis',
      processing: 'Memproses',
      submitCertRequest: 'Kirim Permintaan',
      submitting: 'Mengirim...',
      cert: 'Sertifikat',
    },
    auth: {
      login: 'Masuk',
      register: 'Daftar',
      email: 'Email',
      password: 'Kata Sandi',
      confirmPassword: 'Konfirmasi Kata Sandi',
      name: 'Nama Lengkap',
      nameKana: 'Nama (Fonetik)',
      phone: 'Telepon',
      birthDate: 'Tanggal Lahir',
      address: 'Alamat',
      company: 'Perusahaan',
      loginButton: 'Masuk',
      registerButton: 'Daftar',
      switchToRegister: 'Daftar di sini',
      switchToLogin: 'Masuk di sini',
      forgotPassword: 'Lupa kata sandi?',
      loginSuccess: 'Berhasil masuk',
      loginError: 'Gagal masuk',
      registerSuccess: 'Pendaftaran selesai',
      registerError: 'Pendaftaran gagal',
      emailRequired: 'Email wajib diisi',
      passwordRequired: 'Kata sandi wajib diisi',
      passwordMismatch: 'Kata sandi tidak cocok',
      verifyEmail: 'Verifikasi Email',
      verifyEmailMessage: 'Email verifikasi telah dikirim. Silakan periksa email Anda.',
      alreadyHaveAccount: 'Sudah punya akun?',
      noAccount: 'Belum punya akun?',
    },
  },
  tl: {
    mypage: {
      title: 'Aking Pahina',
      welcome: 'Maligayang Pagdating',
      logout: 'Mag-logout',
      tabs: {
        profile: 'Profile',
        courses: 'Aking mga Kurso',
        certificates: 'Mga Sertipiko',
        documents: 'Mga Dokumento',
      },
      profile: {
        title: 'Pangunahing Impormasyon',
        name: 'Pangalan',
        nameKana: 'Pangalan (Phonetic)',
        email: 'Email',
        phone: 'Telepono',
        birthDate: 'Petsa ng Kapanganakan',
        address: 'Address',
        company: 'Kumpanya',
        profileImage: 'Profile na Larawan',
        changeImage: 'Palitan ang Larawan',
        save: 'I-save',
        saveSuccess: 'Na-update ang profile',
        saveError: 'Nabigo ang pag-update ng profile',
        cancel: 'Kanselahin',
        close: 'Isara', incompleteTitle: 'Hindi Kumpleto ang Profile', incompleteDescription: 'May mga field na kulang sa profile. Pakikumpleto para sa tamang pag-isyu ng sertipiko.', incompleteFields: 'Mga kulang na field', editProfile: 'I-edit ang Profile',
        department: 'Departamento',
        edit: 'I-edit',
        female: 'Babae',
        gender: 'Kasarian',
        imageSizeError: 'Masyadong malaki ang laki ng larawan',
        imageUpdated: 'Na-update ang profile na larawan',
        imageUploadError: 'Nabigo ang pag-upload ng larawan',
        male: 'Lalaki',
        nationality: 'Nasyonalidad', language: 'Wika ng Materyal', selectPlease: 'Pumili',
        postalCode: 'Postal Code',
      },
      courses: {
        title: 'Aking mga Kurso',
        noCourses: 'Walang nakalistang kurso',
        progress: 'Progreso',
        startLearning: 'Magsimulang Mag-aral',
        continueLearning: 'Ipagpatuloy ang Pag-aaral',
        completed: 'Nakumpleto',
        videos: 'Mga Video',
        quizzes: 'Mga Quiz',
        certificate: 'Sertipiko',
        requestCertificate: 'Humiling ng Sertipiko',
        viewCertificate: 'Tingnan ang Sertipiko',
        graduated: 'Nagtapos',
      },
      certificates: {
        title: 'Aking mga Sertipiko',
        noCertificates: 'Walang sertipiko',
        certNumber: 'Numero ng Sertipiko',
        courseName: 'Pangalan ng Kurso',
        completionDate: 'Petsa ng Pagkumpleto',
        issueDate: 'Petsa ng Pag-isyu',
        status: 'Status',
        download: 'I-download',
        downloadPdf: 'I-download ang PDF Sertipiko',
        requestNew: 'Humiling ng Bago',
        pending: 'Pending',
        issued: 'Naibigay',
        card: 'Uri ng Card',
        digital: 'Digital na Sertipiko',
        types: 'Mga Uri ng Sertipiko',
        downloadError: 'Nabigo ang pag-download',
        downloaded: 'Nakumpleto ang download',
        generating: 'Ginagawa...',
        requestFailed: 'Nabigo ang kahilingan',
        requested: 'Matagumpay na hiniling',
        needPracticalReserve: 'Upang humiling ng sertipiko, kailangan mong dumalo at pumasa sa praktikal na pagsasanay. I-book ito gamit ang "I-book ang Praktika" sa itaas.',
        practicalPending: 'Pinoproseso ang iyong booking sa praktika. Dumalo sa pagsasanay kapag nakumpirma na ang petsa.',
        practicalApproved: 'Nakumpirma na ang petsa ng praktikal na pagsasanay. Maaari kang humiling ng sertipiko pagkatapos dumalo at pumasa.',
        practicalFailed: 'Hindi maibibigay ang sertipiko dahil hindi pumasa sa praktikal na pagsasanay. Makipag-ugnayan sa opisina tungkol sa muling pagkuha.',
        stepReserve: 'Mag-book',
        stepConfirm: 'Petsa',
        stepAttend: 'Pumasa',
      },
      documents: {
        title: 'Pamamahala ng Dokumento',
        idDocuments: 'Mga ID Document',
        certDocuments: 'Mga Sertipikasyon',
        front: 'Harap',
        back: 'Likod',
        upload: 'Mag-upload',
        uploadSuccess: 'Matagumpay na na-upload',
        uploadError: 'Nabigo ang pag-upload',
        noDocument: 'Hindi pa naisumite',
        viewHistory: 'Tingnan ang Kasaysayan',
        frontHistory: 'Kasaysayan ng Harap',
        backHistory: 'Kasaysayan ng Likod',
        onlyImages: 'Mga file ng larawan lamang ang pwedeng i-upload',
        maxFileSize: 'Ang laki ng file ay dapat 10MB o mas mababa',
      },
      quickActions: {
        apply: 'Mag-apply sa Kurso',
        history: 'Kasaysayan ng Aplikasyon',
        editProfile: 'I-edit ang Profile',
        inProgress: 'Mga Kasalukuyang Kurso',
        qualifications: 'Mga Kwalipikasyon',
        invoices: 'Mga Invoice',
        documents: 'Mga Dokumento',
        practical: 'Reserbasyon sa Praktika',
      },
      applications: {
        appliedDate: 'Petsa ng Aplikasyon',
        pending: 'Pending',
        contacted: 'Nakontact',
        confirmed: 'Nakumpirma',
        passed: 'Pumasa',
        failed: 'Hindi Pumasa',
      },
      invoices: {
        title: 'Listahan ng Invoice',
        noInvoices: 'Walang invoice', unpaid: 'Hindi Bayad', paid: 'Bayad Na',
        paid: 'Bayad na',
        unpaid: 'Hindi pa bayad',
      },
      practical: {
        submitted: 'Naisumite ang reserbasyon sa praktika',
        submitFailed: 'Nabigo ang pagsumite',
      },
      addNew: 'Magdagdag ng Bago',
      applicationDetails: 'Mga Detalye ng Aplikasyon',
      bank: 'Pangalan ng Bangko:',
      cancelled: 'Kinansela',
      cardCertRequest: 'Kahilingan ng Card Sertipiko',
      cardCertRequested: 'Naisumite ang kahilingan ng card sertipiko',
      certBackHistory: 'Kasaysayan ng Sertipiko (Likod)',
      certFrontHistory: 'Kasaysayan ng Sertipiko (Harap)',
      certTypeLabel: 'Uri ng Sertipiko',
      completeVideos: 'Pakipanood ang lahat ng video',
      completedDate: 'Petsa ng Pagkumpleto:',
      courseDate: 'Petsa ng Kurso:',
      digitalCertRequest: 'Kahilingan ng Digital Sertipiko',
      digitalCertRequested: 'Naisumite ang kahilingan ng digital sertipiko',
      id: 'ID Document',
      idBackHistory: 'Kasaysayan ng ID (Likod)',
      idFrontHistory: 'Kasaysayan ng ID (Harap)',
      loggedOut: 'Naka-logout na',
      notes: 'Mga Tala',
      other: 'Iba pa',
      passQuizzes: 'Pakipasa ang lahat ng quiz',
      processing: 'Pinoproseso',
      submitCertRequest: 'Isumite ang Kahilingan',
      submitting: 'Isinusumite...',
      cert: 'Sertipiko',
    },
    auth: {
      login: 'Mag-login',
      register: 'Mag-register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Kumpirmahin ang Password',
      name: 'Buong Pangalan',
      nameKana: 'Pangalan (Phonetic)',
      phone: 'Telepono',
      birthDate: 'Petsa ng Kapanganakan',
      address: 'Address',
      company: 'Kumpanya',
      loginButton: 'Mag-login',
      registerButton: 'Mag-register',
      switchToRegister: 'Mag-register dito',
      switchToLogin: 'Mag-login dito',
      forgotPassword: 'Nakalimutan ang password?',
      loginSuccess: 'Matagumpay na naka-login',
      loginError: 'Nabigo ang pag-login',
      registerSuccess: 'Nakumpleto ang pagpaparehistro',
      registerError: 'Nabigo ang pagpaparehistro',
      emailRequired: 'Kinakailangan ang email',
      passwordRequired: 'Kinakailangan ang password',
      passwordMismatch: 'Hindi tumutugma ang mga password',
      verifyEmail: 'I-verify ang Email',
      verifyEmailMessage: 'Naipadala ang verification email. Pakicheck ang iyong email.',
      alreadyHaveAccount: 'Mayroon ka nang account?',
      noAccount: 'Wala pang account?',
    },
  },
  zh: {
    mypage: {
      title: '我的页面',
      welcome: '欢迎',
      logout: '退出登录',
      tabs: {
        profile: '个人资料',
        courses: '正在学习的课程',
        certificates: '我的资格',
        documents: '证件管理',
      },
      profile: {
        title: '基本信息',
        name: '姓名',
        nameKana: '假名',
        email: '电子邮箱',
        phone: '电话号码',
        birthDate: '出生日期',
        address: '住址',
        company: '公司名称',
        profileImage: '头像',
        changeImage: '更换头像',
        save: '保存',
        saveSuccess: '个人资料已更新',
        saveError: '个人资料更新失败',
        cancel: '取消',
        close: '关闭', incompleteTitle: '个人信息未填写', incompleteDescription: '您的个人资料存在未填写项。为准确发放证书，请完善信息。', incompleteFields: '未填写项', editProfile: '编辑个人资料',
        department: '部门',
        edit: '编辑',
        female: '女',
        gender: '性别',
        imageSizeError: '图片尺寸过大',
        imageUpdated: '头像已更新',
        imageUploadError: '头像上传失败',
        male: '男',
        nationality: '国籍', language: '教材语言', selectPlease: '请选择',
        postalCode: '邮政编码',
      },
      courses: {
        title: '正在学习的课程',
        noCourses: '暂无正在学习的课程',
        progress: '进度',
        startLearning: '开始学习',
        continueLearning: '继续学习',
        completed: '已完成',
        videos: '视频',
        quizzes: '测验',
        certificate: '结业证书',
        requestCertificate: '申请结业证书',
        viewCertificate: '查看结业证书',
        graduated: '结业',
      },
      certificates: {
        title: '我的资格',
        noCertificates: '暂无资格',
        certNumber: '证书编号',
        courseName: '课程名称',
        completionDate: '结业日期',
        issueDate: '发行日期',
        status: '状态',
        download: '下载',
        downloadPdf: '下载PDF证书',
        requestNew: '新申请',
        pending: '申请中',
        issued: '已发行',
        card: '卡片式',
        digital: '电子证书',
        types: '证书类型',
        downloadError: '下载失败',
        downloaded: '下载完成',
        generating: '生成中...',
        requestFailed: '申请失败',
        requested: '已申请',
        needPracticalReserve: '申请结业证书需要参加并通过实操培训。请使用上方的“实操预约”按钮进行预约。',
        practicalPending: '您的实操预约正在处理中。日程确认后请参加培训。',
        practicalApproved: '实操培训日程已确认。参加并通过后即可申请结业证书。',
        practicalFailed: '由于实操培训未通过，无法发放结业证书。关于重考事宜请联系事务局。',
        stepReserve: '预约',
        stepConfirm: '日程确认',
        stepAttend: '参加合格',
      },
      documents: {
        title: '证件管理',
        idDocuments: '身份证件',
        certDocuments: '资格证书',
        front: '正面',
        back: '反面',
        upload: '上传',
        uploadSuccess: '上传成功',
        uploadError: '上传失败',
        noDocument: '未提交',
        viewHistory: '查看历史',
        frontHistory: '正面历史',
        backHistory: '反面历史',
        onlyImages: '仅可上传图片文件',
        maxFileSize: '文件大小请控制在10MB以内',
      },
      quickActions: {
        apply: '课程报名',
        history: '报名记录',
        editProfile: '编辑资料',
        inProgress: '学习中',
        qualifications: '我的资格',
        invoices: '账单',
        documents: '证件管理',
        practical: '实操预约',
      },
      applications: {
        appliedDate: '报名日期',
        pending: '受理中',
        contacted: '已联系',
        confirmed: '已确定',
        passed: '结业合格',
        failed: '结业不合格',
      },
      invoices: {
        title: '账单一览',
        noInvoices: '暂无账单', unpaid: '未付款', paid: '已付款',
      },
      practical: {
        submitted: '实操预约已申请',
        submitFailed: '申请失败',
      },
      addNew: '新增',
      applicationDetails: '报名详情',
      bank: '银行名称:',
      cancelled: '已取消',
      cardCertRequest: '卡片式证书发行申请',
      cardCertRequested: '已发送卡片式证书发行申请',
      certBackHistory: '资格证书（反面）历史',
      certFrontHistory: '资格证书（正面）历史',
      certTypeLabel: '结业证书类型',
      completeVideos: '请完成所有视频的观看',
      completedDate: '完成日期:',
      courseDate: '学习日期:',
      digitalCertRequest: '电子证书发行申请',
      digitalCertRequested: '已发送电子证书发行申请',
      id: '身份证',
      idBackHistory: '身份证件（反面）历史',
      idFrontHistory: '身份证件（正面）历史',
      loggedOut: '已退出登录',
      notes: '注意事项',
      other: '其他',
      passQuizzes: '请通过所有测验',
      processing: '处理中',
      submitCertRequest: '发送发行申请',
      submitting: '发送中...',
      cert: '资格证',
    },
    auth: {
      login: '登录',
      register: '注册',
      email: '电子邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      name: '姓名',
      nameKana: '假名',
      phone: '电话号码',
      birthDate: '出生日期',
      address: '住址',
      company: '公司名称',
      loginButton: '登录',
      registerButton: '注册',
      switchToRegister: '点此注册',
      switchToLogin: '点此登录',
      forgotPassword: '忘记密码',
      loginSuccess: '登录成功',
      loginError: '登录失败',
      registerSuccess: '注册完成',
      registerError: '注册失败',
      emailRequired: '电子邮箱为必填项',
      passwordRequired: '密码为必填项',
      passwordMismatch: '密码不一致',
      verifyEmail: '邮箱验证',
      verifyEmailMessage: '验证邮件已发送，请查收邮箱。',
      alreadyHaveAccount: '已有账户？',
      noAccount: '还没有账户？',
    },
  },
};
